// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"817aa65a","707":"3424a9dc","729":"47c09a7f"}[chunkId] + ".js";
};